import { GoogleAnalytics } from "../analytics/ga";
import { MetaPixel } from "../analytics/pixel";

const registry = {
	ga: new GoogleAnalytics(),
	pixel: new MetaPixel(),
};

export { registry };
